module.exports = __webpack_public_path__ + "img/wheel.bf72992c.png";